import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-bootstrap/Modal';
import ReactLoading from 'react-loading';
import PrimaryTable from '../helpers/primary-table'
import { catchError } from '../helpers/catch-error-client'


const Patients = () => {
  const navigate = useNavigate();
  const [patientEdit, setPatientEdit] = useState();
  const [patientSearch, setPatientSearch] = useState(null);
  const [isBtn, setIsBtn] = useState(false)
  const [inputError, setInputError] = useState(false);
  const [patients, setPatients] = useState(null);
  const [searchMode, setSearchMode] = useState(false);
  const [editPatientModalOpen, setEditPatientModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  var columns = React.useMemo(
    () => [
      {
        accessorFn: row => <span className="btn  btn-link" onClick={() => editPatient(row.patient_id)} >EDIT</span>,
        id: "action",
        cell: info => info.getValue(),
        header: () => "ACTION",
        footer: props => props.column.id,
        enableColumnFilter: false,
            enableSorting: false,
      },
      {
        accessorFn: row => row.patient_last_name + " " + row.patient_middle_name + " " + row.patient_first_name,
        id: "lastName",
        cell: info => info.getValue(),
        header: () => "Name",
        footer: props => props.column.id
      },
      {
        accessorKey: "patient_dob_formatted",
        header: "DOB",
        footer: props => props.column.id
      },
      {
        accessorKey: "patient_ssn",
        header: "SSN",
        footer: props => props.column.id
      },
      {
        accessorKey: "patient_med_rec_num",
        header: "MEDICAL RECORD#",
        footer: props => props.column.id
      },
      {
        accessorKey: "patient_email",
        header: "Email",
        footer: props => props.column.id
      },
      {
        accessorKey: "patient_phone_number",
        header: "Phone",
        footer: props => props.column.id
      }
    ],
    []
  )




  useEffect(() => {

    getPatients();

  }, []);




  const getPatients = async () => {
    setIsLoading(true);
    setPatientEdit(null);
    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-patients",  {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {

      if (response?.data?.status) {

        setPatients(response?.data?.patients);
        setIsLoading(false);

      } else {

        Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });

      }
    }).catch(function (error) {

      Swal.fire({ icon: "error", title: "Patient Info", text: "Patient edit information Failed to Load" });

    });

  }




  const editPatient = async (patient_id) => {

    setPatientEdit(null);
    setIsLoading(true);
    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-patient-by-id/" + patient_id, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {
      setIsLoading(false);
      if (response?.data?.status) {

        let p = response?.data?.patient;
        p.patient_dob = p.patient_dob_formatted;
        setEditPatientModalOpen(true);
        setPatientEdit(p);


      } else {

        Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });

      }
    }).catch(function (error) {
      setIsLoading(false);
      Swal.fire({ icon: "error", title: "Patient Info", text: "Patient edit information Failed to Load" });

    });

  }


  const updatePatient = async (e) => {

    setIsBtn(true);
    let error_flag = false;

    const { patient_first_name, patient_middle_name, patient_last_name, patient_dob, patient_ssn } = patientEdit;
    let patient_email = patientEdit.patient_email;
    if ((patient_email) && !patient_email?.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) {
      error_flag = true;
    }

    if (!patient_first_name || !patient_last_name || !patient_dob || !patient_ssn ||
      !(patient_first_name?.match(/^[A-Za-z'.\-, ]+$/)) || !(patient_middle_name?.match(/^[A-Za-z'.\-, ]+$/)) || !(patient_last_name?.match(/^[A-Za-z'.\-, ]+$/)) ||
      !/^\d{2}\/\d{2}\/\d{4}$/.test(patient_dob) || !/^\d{3}-\d{2}-\d{4}$/.test(patient_ssn)) {

      error_flag = true;
    }

    if (error_flag) {

      setInputError(true);
      setIsBtn(false);

    } else {

      var patient_info = {
        patient_id: patientEdit?.patient_id,
        patient_first_name: patientEdit?.patient_first_name,
        patient_middle_name: patientEdit?.patient_middle_name,
        patient_last_name: patientEdit?.patient_last_name,
        patient_dob: patientEdit?.patient_dob,
        patient_ssn: patientEdit?.patient_ssn,
        patient_med_rec_num: patientEdit?.patient_med_rec_num,
        patient_address: patientEdit?.patient_address,
        patient_phone_number: patientEdit?.patient_phone_number,
        patient_email: patientEdit?.patient_email,

      }
      axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/update-patient", patient_info, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      }).then(async function (response) {

        if (response?.data?.status) {

          Swal.fire({ icon: "success", title: "Patient Update", text: "Patient updated successfully" });
          getPatients();
          setEditPatientModalOpen(false);

        } else {
          Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });

        }
        setIsBtn(false)

      }).catch(function (error) {

        setIsBtn(false);
        catchError(error,navigate)
      });

    }


  }


  const searchPatients = () => {

    setIsLoading(true);

    var search_elements = {}

    search_elements.patient_first_name = patientSearch?.patient_first_name;
    search_elements.patient_middle_name = patientSearch?.patient_middle_name;
    search_elements.patient_last_name = patientSearch?.patient_last_name;
    search_elements.patient_dob = patientSearch?.patient_dob;
    search_elements.patient_ssn = patientSearch?.patient_ssn;
    search_elements.patient_med_rec_num = patientSearch?.patient_med_rec_num;
    search_elements.client_company_name = patientSearch?.client_company_name;
    search_elements.facility_name = patientSearch?.facility_name;
    search_elements.wo_policy_number = patientSearch?.wo_policy_number;
    search_elements.limit = 200;


    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/search-patients", search_elements, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {


      if (response?.data?.status) {


        setPatients(response?.data?.patients);

      }
      else {
        setPatients(null);

      }
      setIsLoading(false);
    }).catch(function (error) {

      setIsLoading(false);
      catchError(error,navigate)

    });


  }


  const resetSearchPatients = () => {

    setPatientSearch(null);
    getPatients();

  }



  return (
    <>



      <div className="row pb-2 mt-4">
        <div className="col-md-4 col-sm-12 ps-3 ">
          <h3 className="text-dark my-0">PATIENTS</h3>
        </div>

        <div className="col-md-8 col-sm-12 text-md-end -2">
          {!searchMode &&
            <>
              <button onClick={() => { setSearchMode(true); resetSearchPatients() }} className="btn btn-success">SEARCH</button>
            </>
          }
        </div>
      </div>

   

      { searchMode &&
      <>
        <div className="card card-form card-primary mb-3">
          <div className="card-heading px-5 py-2"><h6 className="fw-bold my-0">SEARCH PATIENTS</h6></div>
          <div className="card-body">
            <form className="form-horizontal form-thick mb-2"  >


              <div className="row px-5 gx-5">

                <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
                  <label htmlFor="patient_first_name" >First Name</label>
                  <input name="patient_first_name" className="form-control" type="text"
                    value={patientSearch?.patient_first_name}
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_first_name: e.target.value })
                    }

                  />


                </div>
                <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
                  <label htmlFor="patient_middle_name">Middle Name</label>
                  <input name="patient_middle_name" className="form-control" type="text"
                    value={patientSearch?.patient_middle_name}
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_middle_name: e.target.value })
                    }


                  />
                </div>
                <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
                  <label htmlFor="patient_last_name">Last Name</label>
                  <input name="patient_last_name" className="form-control" type="text"
                    value={patientSearch?.patient_last_name}
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_last_name: e.target.value })
                    }


                  />



                </div>



                <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
                  <label htmlFor="patient_dob">Date of Birth</label>
                  <DatePicker name="patient_dob" id="patient_dob" type="text"
                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={patientSearch?.patient_dob}
                    onChange={(e) =>
                      {
                        var dt = new Date(e);
  
                        const year = dt.getFullYear();
                        const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                        const day = dt.getDate().toString().padStart(2, "0");
      
                        const formatted_date = month + '/' + day + '/' + year
      
                        setPatientSearch({ ...patientSearch, patient_dob: formatted_date })
                       
                      }
                    }
                  />

                </div>
                <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
                  <label htmlFor="patient_ssn">SSN</label>
                  <input name="patient_ssn" id="patient_ssn" type="text" className="form-control"
                    value={patientSearch?.patient_ssn} placeholder="000-00-0000"
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_ssn: e.target.value })
                    }

                  />

                </div>
                <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
                  <label htmlFor="patient_med_rec_num">Medical Record #</label>
                  <input name="patient_med_rec_num" id="patient_med_rec_num" type="text" className="form-control"
                    value={patientSearch?.patient_med_rec_num}
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_med_rec_num: e.target.value })
                    }

                  />

                </div>



                <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
                  <label htmlFor="client_company_name">Client/Company Name</label>
                  <input name="client_company_name" id="client_company_name" type="text" className="form-control"
                    value={patientSearch?.client_company_name} onChange={(e) =>
                      setPatientSearch({ ...patientSearch, client_company_name: e.target.value })
                    }
                  />

                </div>
                <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
                  <label htmlFor="facility_name">Facility Name</label>
                  <input name="facility_name" id="facility_name" type="text" className="form-control"
                    value={patientSearch?.facility_name} onChange={(e) =>
                      setPatientSearch({ ...patientSearch, facility_name: e.target.value })
                    }
                  />

                </div>
                <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
                  <label htmlFor="wo_policy_number">Claim/Policy Number</label>
                  <input name="wo_policy_number" id="wo_policy_number" type="text" className="form-control"
                    value={patientSearch?.wo_policy_number} onChange={(e) =>
                      setPatientSearch({ ...patientSearch, wo_policy_number: e.target.value })
                    }

                  />

                </div>


              </div>


            </form>

          </div>

          <div className="card-footer">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                <button onClick={() => searchPatients()} className="btn btn-success mx-1" type="button" disabled={isLoading?true:false} >{isLoading?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"SEARCH"}</button>
                <button onClick={() => { resetSearchPatients(); setSearchMode(false); }} className="btn btn-warning mx-1" type="button">CANCEL SEARCH </button>
              </div>

            </div>
          </div>
        </div>


      </>
}

{
  isLoading ?

    <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />

    :
    <>


      {patients &&
        <>
          <div className="card card-form card-primary  h-100 " >
            <div className="card-body p-0 mb-5" >


              <PrimaryTable columns={columns} data={patients} />
            </div></div>
        </>
      }
    </>
}









<Modal animation={false}
  show={editPatientModalOpen}
  onHide={() => { setEditPatientModalOpen(false); }}
  keyboard={false}
  backdrop="static"
  id="search-patient-modal"
  size="lg"
>
  <Modal.Header><h3 className="m-0 p-0">UPDATE PATIENT</h3></Modal.Header>
  <Modal.Body>
    <div className="modal-inner-content form-thick">


      {isLoading ?
        <div className="text-center m-auto loader" >
          <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
        </div>
        :


        <>
          <div className="row px-5 py-1 gx-5 ">

            <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
              <label htmlFor="patient_first_name" >First Name*</label>

              <input name="patient_first_name" className="form-control" type="text"
                value={patientEdit?.patient_first_name}
                onChange={(e) =>
                  setPatientEdit({ ...patientEdit, patient_first_name: e.target.value })
                }


              />
              {inputError &&
                (!patientEdit?.patient_first_name || !(patientEdit?.patient_first_name?.match(/^[A-Za-z'.\-, ]+$/))) && (
                  <span className="text-danger">Enter valid first name</span>
                )}




            </div>
            <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
              <label htmlFor="patient_middle_name">Middle Name</label>

              <input name="patient_middle_name" className="form-control" type="text"
                value={patientEdit?.patient_middle_name}
                onChange={(e) =>
                  setPatientEdit({ ...patientEdit, patient_middle_name: e.target.value })
                }

              />
             {inputError &&
  patientEdit?.patient_middle_name && // validate only if not empty
  !patientEdit.patient_middle_name.match(/^[A-Za-z'.\-, ]+$/) && (
    <span className="text-danger">Enter valid middle name</span>
)}


            </div>
            <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
              <label htmlFor="patient_last_name">Last Name*</label>
              <input name="patient_last_name" className="form-control" type="text"
                value={patientEdit?.patient_last_name}
                onChange={(e) =>
                  setPatientEdit({ ...patientEdit, patient_last_name: e.target.value })
                }

              />
              {inputError &&
                (!patientEdit?.patient_last_name || !(patientEdit?.patient_last_name?.match(/^[A-Za-z'.\-, ]+$/))) && (
                  <span className="text-danger">Enter valid Last name</span>
                )}

            </div>

            <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
              <label htmlFor="patient_dob">Date of Birth*</label>
              <DatePicker name="patient_dob" id="patient_dob" type="text"
                className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={patientEdit?.patient_dob}
                onChange={(e) => {
                  var dt = new Date(e);

                  const year = dt.getFullYear();
                  const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                  const day = dt.getDate().toString().padStart(2, "0");

                  const formatted_date = month + '/' + day + '/' + year

                  setPatientEdit({ ...patientEdit, patient_dob: formatted_date })

                }
                }
              />
              {inputError &&
                (!patientEdit?.patient_dob || !/^\d{2}\/\d{2}\/\d{4}$/.test(patientEdit?.patient_dob)) && (
                  <span className="text-danger">Enter valid date of birth</span>
                )}

            </div>
            <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
              <label htmlFor="patient_ssn">SSN*</label>

              <input name="patient_ssn" id="patient_ssn" type="text" className="form-control"
                value={patientEdit?.patient_ssn} placeholder="000-00-0000"
                onChange={(e) =>
                  setPatientEdit({ ...patientEdit, patient_ssn: e.target.value })
                }
                onKeyUp={(e) => {
                  if (!/^[0-9\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {inputError &&
                (!patientEdit?.patient_ssn || !/^\d{3}-\d{2}-\d{4}$/.test(patientEdit?.patient_ssn)) && (
                  <span className="text-danger">Enter a valid SSN</span>
                )}

            </div>
            <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
              <label htmlFor="patient_med_rec_num">Medical Record #</label>

              <input name="patient_med_rec_num" id="patient_med_rec_num" type="text"
                className="form-control"
                value={patientEdit?.patient_med_rec_num} onChange={(e) =>
                  setPatientEdit({ ...patientEdit, patient_med_rec_num: e.target.value })
                }
              />

            </div>



            <div className="col-xl-4  col-lg-4 col-sm-12 my-1">

              <label htmlFor="patient_address" >ADDRESS</label>

              <input name="patient_address" id="patient_address" type="text" className="form-control"
                value={patientEdit?.patient_address} onChange={(e) =>
                  setPatientEdit({ ...patientEdit, patient_address: e.target.value })
                }
              />

            </div>
            <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
              <label htmlFor="patient_phone_number">PHONE NUMBER</label>

              <input name="patient_phone_number" id="patient_phone_number" type="text" className="form-control"
                value={patientEdit?.patient_phone_number} onChange={(e) =>
                  setPatientEdit({ ...patientEdit, patient_phone_number: e.target.value })
                }

              />

            </div>
            <div className="col-xl-4  col-lg-4 col-sm-12 my-1">
              <label htmlFor="patient_email">EMAIL</label>

              <input name="patient_email" id="patient_email" type="text" className="form-control"
                value={patientEdit?.patient_email} onChange={(e) =>
                  setPatientEdit({ ...patientEdit, patient_email: e.target.value })
                }
              />
              {inputError &&
                (patientEdit?.patient_email && !patientEdit?.patient_email?.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) && (
                  <span className="text-danger">Enter a valid email</span>
                )}


            </div>

          </div>

        </>
      }

    </div>
  </Modal.Body>
  <Modal.Footer>

    <button type='button' onClick={() => updatePatient()} className="btn  btn-success" disabled={isBtn}>
      {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status">

      </div><span className="sr-only">Loading...</span></> : 'UPDATE PATIENT'}
    </button>
    <button type='button' className="btn  btn-warning" onClick={(e) => setEditPatientModalOpen(false)}  >CANCEL UPDATE</button>


  </Modal.Footer>
</Modal>






    </>

  );
};

export default Patients;